import {
  ADD_SERVICE,
  ADD_SERVICE_ERROR,
  ADD_SERVICE_SUCCESS,
  DELETE_SERVICE,
  DELETE_SERVICE_ERROR,
  DELETE_SERVICE_SUCCESS,
  GET_SERVICES,
  GET_SERVICES_ERROR,
  GET_SERVICES_SUCCESS,
  GET_SERVICE,
  GET_SERVICE_SUCCESS,
  UPDATE_SERVICE,
  UPDATE_SERVICE_ERROR,
  UPDATE_SERVICE_SUCCESS,
  UPLOAD_SERVICE_ICON,
  UPLOAD_SERVICE_ICON_ERROR,
  UPLOAD_SERVICE_ICON_SUCCESS,
  TOGGLE_SERVICE_MODAL,
} from "./actionTypes";

export const getServices = (request) => {
  return {
    type: GET_SERVICES,
    payload: { request },
  };
};

export const getServicesSuccess = (paginatedServices) => {
  return {
    type: GET_SERVICES_SUCCESS,
    payload: paginatedServices,
  };
};

export const getServicesError = (message) => {
  return {
    type: GET_SERVICES_ERROR,
    payload: message,
  };
};

export const addService = (request) => {
  return {
    type: ADD_SERVICE,
    payload: { request },
  };
};

export const addServiceSuccess = () => {
  return {
    type: ADD_SERVICE_SUCCESS,
  };
};

export const addServiceError = (error) => {
  return {
    type: ADD_SERVICE_ERROR,
    payload: error,
  };
};

export const getService = (id) => {
  return {
    type: GET_SERVICE,
    payload: { id },
  };
};

export const getServiceSuccess = (customer) => {
  return {
    type: GET_SERVICE_SUCCESS,
    payload: customer,
  };
};

export const getServiceError = (message) => {
  return {
    type: GET_SERVICES_ERROR,
    payload: message,
  };
};

export const updateService = (request) => {
  return {
    type: UPDATE_SERVICE,
    payload: { request },
  };
};

export const updateServiceSuccess = () => {
  return {
    type: UPDATE_SERVICE_SUCCESS,
  };
};

export const updateServiceError = (error) => {
  return {
    type: UPDATE_SERVICE_ERROR,
    payload: error,
  };
};

export const deleteService = (id) => {
  return {
    type: DELETE_SERVICE,
    payload: { id },
  };
};

export const deleteServiceSuccess = () => {
  return {
    type: DELETE_SERVICE_SUCCESS,
  };
};

export const deleteServiceError = (error) => {
  return {
    type: DELETE_SERVICE_ERROR,
    payload: error,
  };
};

export const uploadServiceIcon = (icon) => {
  return {
    type: UPLOAD_SERVICE_ICON,
    payload: { icon },
  };
};

export const uploadServiceIconSuccess = (icon) => {
  return {
    type: UPLOAD_SERVICE_ICON_SUCCESS,
    payload: icon,
  };
};

export const uploadServiceIconError = (error) => {
  return {
    type: UPLOAD_SERVICE_ICON_ERROR,
    payload: error,
  };
};

export const toggleServiceModalAction = () => {
  return {
    type: TOGGLE_SERVICE_MODAL,
  };
};
